import React, { useState } from 'react';
import base64 from 'base-64';
import { GoogleLogin } from '@react-oauth/google';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { useNavigate } from 'react-router-dom';
import { SERVER_BASE_URL } from '../constants';
import './LoginButtons.css';

const GoogleLoginButton = () => {
    const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
    const apiKey = process.env.REACT_APP_X_API_KEY;
    const navigate = useNavigate();
    const [isLoading, setLoading] = useState(false); // 초기에는 로딩 중이 아님

    const handleLoginSuccess = (res) => {
        setLoading(true); // 로딩 시작

        let token = res.credential;
        let payload = res.credential.substring(token.indexOf('.') + 1, token.lastIndexOf('.'));
        let dec = base64.decode(payload);
        let decJson = JSON.parse(dec);
        let userId = decJson['email'] + '-G';

        console.log(userId);

        fetch(`${SERVER_BASE_URL}/sign-in`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': apiKey,
            },
            body: JSON.stringify({ 'user_id': userId }),
        })
            .then(response => {
                setLoading(false); // 로딩 종료

                if (response.ok) {
                    return response.json();
                } else if (response.status === 404) {
                    alert('회원정보가 존재하지 않습니다.');
                    throw new Error('User not found.');
                } else {
                    throw new Error('Network response was not ok.');
                }
            })
            .then(data => {
                console.log('Success:', data);
                const authToken = data.authorization_token;
                localStorage.setItem('authorization_token', authToken);
                navigate('/main');
            })
            .catch(error => {
                setLoading(false); // 로딩 종료
                console.error('Error:', error);
            });
    };

    const handleLoginFailure = (err) => {
        console.log(err);
    };

    return (
        <GoogleOAuthProvider clientId={clientId}>
            <GoogleLogin
                className="login-button google-login-button"
                onSuccess={handleLoginSuccess}
                onFailure={handleLoginFailure}
            />
            {isLoading && (
                <div className="loading-overlay">
                    Loading...
                </div>
            )}
        </GoogleOAuthProvider>
    );
};

export default GoogleLoginButton;
